<template>
  <div class="home" :class="{'active': activeLoader}">
    <template v-if="activeLoader">
      <LoaderBarBox></LoaderBarBox>
    </template>
    <router-view name="mainBox"></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'home',
  components: {
    LoaderBarBox: () => import('../components/LoaderBarBox'),
  },
  computed: {
    ...mapGetters([
      'activeLoader',
    ]),
  },
};
</script>
<style lang="scss" scoped>
  .home {
    height: 100%;
    position: relative;
  }
</style>
